import ConnectedSliderRange from "components/screener/shared/ConnectedSliderRange";

export default function NetMargin() {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h3 className="font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500">Margem</h3>
        <span className="flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400">
          Filtre por margem de lucro.
        </span>
      </div>

      <ConnectedSliderRange
        attribute="lastYearlyFinancials.netMargin"
        label="Margem líquida"
        accessibilityLabels={["Margem de lucro mínima", "Margem de lucro máxima"]}
      />
    </div>
  );
}
